import map from 'lodash/map';
import { MockedGoogleOptimizeInstance } from '@/modules/Broadband/__test__/mocks';

export const EXPERIMENT_IDS = {
    hide200: 'x2KJ_7WLRmGz0XxKnKf6aQ',
    hideSTNNotice: '88c5Z6FtQ7y0iuoHyWee0w',
};

export type GoogleOptimizeExperiment = {
    id: string;
    active_variant?: string; // '0', '1' etc.
};

export interface GoogleOptimize {
    get: (experiment_id: string) => string | undefined;
    active_experiments?: GoogleOptimizeExperiment[];
}

const theMockedOptimizeInstance = new MockedGoogleOptimizeInstance([]);

export function getGoogleOptimizeInstance(): GoogleOptimize | undefined {
    if (process.env.NODE_ENV === 'development') {
        return theMockedOptimizeInstance;
    } else if (process.env.NODE_ENV === 'production') {
        return window.google_optimize as GoogleOptimize;
    } else {
        return undefined;
    }
}

export default class ABTesting {
    google_optimize_instance: GoogleOptimize | undefined;

    constructor(
        google_optimize_instance:
            | GoogleOptimize
            | undefined = getGoogleOptimizeInstance()
    ) {
        this.google_optimize_instance = google_optimize_instance;
    }

    get active_experiments(): GoogleOptimizeExperiment[] {
        if (typeof this.google_optimize_instance !== 'undefined') {
            const returnValue = map(EXPERIMENT_IDS, (id) => {
                const active_variant =
                    this.google_optimize_instance &&
                    this.google_optimize_instance.get(id);
                return { id, active_variant };
            });

            // console.log('active_experiments', returnValue);

            return returnValue;
        } else {
            return [];
        }
    }

    experimentIsActive(experiment_id: string): boolean {
        const matching_experiment = this.active_experiments.find(
            (experiment) => experiment.id === experiment_id
        );

        if (matching_experiment) {
            return matching_experiment.active_variant !== undefined;
        } else {
            return false;
        }
    }

    getVariantOfExperiment(experiment_id: string): string | undefined {
        const matching_experiment = this.active_experiments.find(
            (experiment) => experiment.id === experiment_id
        );
        if (matching_experiment) {
            return matching_experiment.active_variant;
        } else {
            return undefined;
        }
    }
}

export const theLiveABTest = new ABTesting(getGoogleOptimizeInstance());
